import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteBeehiivConfigurationMutation = createMutationHook(
  CreatorIntegrationsApiClient.deleteBeehiivConfiguration,
  {
    mutationKey: ['deleteBeehiivConfiguration'],
  },
)
